/*
 * Copyright (c) MLCommons and its affiliates.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 * Copyright (c) MLCommons, Inc. and its affiliates.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from "react";
import { Container, Col } from "react-bootstrap";

const TermsPage = () => (
  <Container className="mb-5 pb-5">
    <Col className="m-auto" lg={9}>
      <h1 className="my-4 pt-3 text-uppercase">Terms of Use</h1>
      <p>Effective Date: December 1, 2020</p>
      <br />
      <p>
        These Terms of Use (“Terms”) govern the use of the Dynabench website
        (the “Website”). These Terms constitute an agreement between you and
        MLCommons, Inc. (“MLCommons,” “us,”, “we”, “our”) so it is important
        that you review them carefully. We reserve the right to change these
        Terms at any time. Your continued use of the Website following the
        posting of changes will confirm that you accept the changed Terms. If
        you do not agree to (or cannot comply with) the changed Terms, you must
        stop using the Website.
      </p>
      <p>
        <strong>Content</strong>
      </p>
      <p>
        The Website is available for a personal and non-commercial use and for
        informational purposes only. You may not access or use the Website if
        you are not at least 18 years old or the age of majority in the
        jurisdiction from which you are accessing the Website.
      </p>
      <p>
        <strong>Ownership</strong>
      </p>
      <p>
        Excluding any User Content and User Models (both terms defined below)
        that you may Submit (defined below), you acknowledge that all
        intellectual property rights, including copyrights, patents, trademarks,
        and trade secrets, in the Website and their content are owned by us or
        our suppliers. Neither these Terms nor your access to the Website
        transfers to you or any third party any rights, title or interest in or
        to such intellectual property rights. We reserve all rights not granted
        in these Terms.
      </p>
      <p>
        <strong>User Content and User Models</strong>
      </p>
      <p>
        “User Content” means any information and content, other than User
        Models, that a user uploads, shares, submits, provides, or otherwise
        makes available or uses with, the Website, including messaging and any
        interactions you may have with our AI systems (collectively, “Submit”).
        Examples include any text, photos, videos, or other media or content.
        “User Model” means any AI model, tasks, software, services,
        applications, or datasets that a user Submits. You assume all risks
        associated with the use of your User Content and your User Models,
        including any disclosure of your User Content or User Models that may
        personally identify you or any third party. We are not obligated to
        backup or save any User Content or User Models. You are solely
        responsible for creating and maintaining your own backup copies of your
        User Content and User Models if you desire.
      </p>
      <p>
        We reserve the right (but have no obligation) to review any User Content
        and User Models, and to investigate and/or take appropriate action
        against you in our sole discretion if you violate any other provision of
        these Terms. Such action may include removing or modifying your User
        Content and User Models and terminating your account.
      </p>
      <p>
        You will not submit any confidential, private or personal information
        when interacting with our AI systems since the information you Submit
        may be later made public as part of an open source dataset that we will
        make available on our Website.
      </p>
      <p>
        To the extent that you submit User Content (e.g. when you interact with
        our AI systems), you hereby grant us (and represent and warrant that you
        have the right to grant) an irrevocable, non-exclusive, royalty-free and
        fully-paid-up, worldwide license to reproduce, distribute, publicly
        display and perform, prepare derivative works of, incorporate into other
        works and otherwise use and exploit such User Content, and to grant
        sublicenses of the foregoing rights. You hereby irrevocably waive (and
        agree to cause to be waived) any claims and assertions of moral rights
        or attribution with respect to any User Content you submit.
      </p>
      <p>
        To the extent that you submit User Models, you hereby grant us (and
        represent and warrant that you have the right to grant) an irrevocable,
        non-exclusive, royalty-free and fully-paid-up, worldwide license to
        reproduce, distribute, publicly display and perform, and otherwise use
        such User Models for the purpose of providing the Website to users, and
        to grant sublicenses of the foregoing rights. You hereby irrevocably
        waive (and agree to cause to be waived) any claims and assertions of
        moral rights or attribution with respect to any User Models you submit.
      </p>
      <p>
        <strong>Accounts</strong>
      </p>
      <p>
        You are responsible for maintaining the confidentiality of your account
        login information and for all activities that occur under your account.
        You should notify us of any unauthorized use, or suspected unauthorized
        use of your account or any other breach of security. We cannot and will
        not be liable for any loss or damage arising from your failure to comply
        with this section.
      </p>
      <p>
        <strong>Prohibited Conduct</strong>
      </p>
      <p>
        You may not access or use, or attempt to access or use, the Website to
        take any action that could harm us or any third party, interfere with
        the operation of the Website, or use the Website in a manner that
        violates any laws. For example, and without limitation, you may not:
      </p>
      <ul>
        <li>
          impersonate any person or entity or otherwise misrepresent your
          affiliation or the origin of any information or materials you submit;
        </li>
        <li>
          engage in unauthorized spidering, “scraping,” or harvesting of content
          or information, or use any other unauthorized automated means to
          compile information from the Website;
        </li>
        <li>
          take any action that imposes an unreasonable or disproportionately
          large load on our network or infrastructure;
        </li>
        <li>
          use any device, software, or routine to interfere or attempt to
          interfere with the proper working of the Website or any activity
          conducted on the Website or attempt to probe, scan, test the
          vulnerability of, or breach the security of any system or network;
        </li>
        <li>
          attempt to decipher, decompile, disassemble, or reverse-engineer any
          of the software or code comprising or in any way making up a part of
          the Website;
        </li>
        <li>
          distribute any unauthorized materials or advertise or promote goods or
          services without our permission (including, without limitation, by
          sending spam);
        </li>
        <li>
          Submit User Content or User Models that infringes on the copyright,
          trademark, patent, or other intellectual property rights of any third
          party, are false, misleading, libelous, defamatory, obscene, abusive,
          hateful, or sexually-explicit, violate a third party’s right to
          privacy or publicity, or degrade others on the basis of gender, race,
          class, ethnicity, national origin, religion, sexual preference,
          disability, or other classification; and
        </li>
        <li>
          engage in any other conduct that restricts or inhibits any person from
          using or enjoying the Website or that, in our sole judgment, exposes
          us or any of our users, affiliates, or any other third party to any
          liability, damages, or detriment of any type.
        </li>
      </ul>
      <p>
        We may suspend or terminate your access to the Website for any reason at
        any time without notice. We also may investigate and work with law
        enforcement authorities to prosecute users who violate the Terms.
        Violations of system or network security may result in civil or criminal
        liability.
      </p>
      <p>
        <strong>Limitation of liability</strong>
      </p>
      <p>
        Your use of the Website is at your own risk. The Website, content and
        information available on the Website are provided “as is” without
        warranties of any kind, either express or implied, including without
        limitation warranties of merchantability, fitness for a particular
        purpose, non-infringement, or other violation of rights. We do not
        warrant the adequacy, currency, accuracy, likely results, or
        completeness of the Website or any third-party sites linked to or from
        the Website, or that the functions provided will be uninterrupted,
        virus, or error-free. We expressly disclaim any liability for any errors
        or omissions in the content included in the Website. We do not control
        or direct what people and others do or say, and we are not responsible
        for their actions or conduct (whether online or offline) or any content
        they share (including offensive, inappropriate, obscene, unlawful, and
        other objectionable content). Some jurisdictions may not allow the
        exclusion of implied warranties, so some of the above exclusions may not
        apply to you.
      </p>
      <p>
        In no event will we, or our subsidiaries, affiliates, directors,
        officers, employees, agents, and assigns be liable for any direct or
        indirect, special, incidental, consequential or punitive damages, lost
        profits, or other damages whatsoever arising in connection with the use
        of the Website, any interruption in availability of the Website, delay
        in operation or transmission, computer virus, loss of data, or use,
        misuse, reliance, review, manipulation, or other utilization in any
        manner whatsoever of the Website or the data collected through the
        Website, even if one or more of them has been advised of the possibility
        of such damages or loss.
      </p>
      <p>
        <strong>Indemnification</strong>
      </p>
      <p>
        You agree to indemnify, defend, and hold us and our subsidiaries,
        affiliates, directors, officers, employees, agents and assigns harmless
        from and against any and all loss, costs, expenses (including reasonable
        attorneys’ fees and expenses), claims, damages, and liabilities related
        to or associated with the User Content, the User Models, your use of the
        Website and any alleged violation by you of these Terms. We reserve the
        right to assume the exclusive defense of any claim for which we are
        entitled to indemnification under this section. In such event, you shall
        provide us with such cooperation as we reasonably request.
      </p>
      <p>
        <strong>Modification</strong>
      </p>
      <p>
        We reserve the right, at any time, to modify, suspend, or discontinue
        all or any elements of the Website (in whole or in part) with or without
        notice to you. In particular, we may remove, at our discretion, any User
        Content and/or User Models from the Website at any time without any
        notice or explanation. You agree that we will not be liable to you or to
        any third party for any such modification, suspension, or
        discontinuation.
      </p>
      <p>
        <strong>Third Party Materials</strong>
      </p>
      <p>
        The Website may contain links to third party content or otherwise
        contain materials that are hosted by another party. We do not control,
        endorse, sponsor, recommend, or otherwise accept responsibility for such
        content. You access these materials at your own risk.
      </p>
      <p>
        <strong>Miscellaneous</strong>
      </p>
      <ol>
        <li>
          You acknowledge and agree that we have no obligation to provide you
          with any support or maintenance in connection with your use of the
          Website.
        </li>
        <li>
          The use of our Website involves the transmission of data through your
          device or network service provider in the case of a mobile device.
          Your network service provider may charge you for this data
          transmission. You are responsible for any and all costs related to
          your use of your device or network service provider.
        </li>
        <li>
          We appreciate your feedback and other suggestions about our Website
          and our AI models. If you submit to us any feedback or suggestions, we
          may use and fully exploit them in any manner that we deem appropriate,
          without any restriction or obligation to compensate you. We will treat
          any feedback or other suggestions as non-confidential and
          non-proprietary. You should not submit to us any information or ideas
          that you consider to be confidential or proprietary.
        </li>
        <li>
          These Terms make up the entire agreement regarding your use of the
          Website. If any portion of these Terms is found to be unenforceable,
          the remaining portion will remain in full force and effect.
        </li>
        <li>
          You agree that no joint venture, partnership, employment, or agency
          relationship exists between you and us as a result of these Terms or
          your access to and use of the Website.
        </li>
        <li>
          Our failure to enforce any provisions of these Terms or respond to a
          violation by any party does not waive our right to subsequently
          enforce any terms or conditions of the Terms or respond to any
          violations. Nothing contained in these Terms is in derogation of our
          right to comply with governmental, court, and law enforcement requests
          or requirements relating to your use of the Website or information
          provided to or gathered by us with respect to such use.
        </li>
        <li>
          If you have any questions or comments about these Terms or our
          practices, please contact us at{" "}
          <a href="mailto:dynabench-site@mlcommons.org">
            dynabench-site@mlcommons.org
          </a>{" "}
          or by mail at:
          <br />
          <br />
          MLCommons, Inc.
          <br />
          ATTN: Privacy Operations
          <br />
          1601 Willow Road
          <br />
          Menlo Park, CA 94025
        </li>
      </ol>
    </Col>
  </Container>
);

export default TermsPage;
